import React from 'react';

export default function PerspectiveHeader({ title, textColor }) {
  return (
    <div className="relative text-center">
      <div className="inline-block bg-white/80 backdrop-blur-md py-3 px-6 rounded-xl shadow-lg border border-gray-200/50">
        <h3 className={`text-2xl font-bold ${textColor}`}>{title}</h3>
      </div>
    </div>
  );
}
